import { createIcon } from '../createIcon';
import { ReactComponent as IconMessengerSupport } from '../svg/messenger-support.svg';

export default createIcon(IconMessengerSupport);
